import React from 'react';
import { Box, Typography, Stack, LinearProgress } from '@mui/material'; 
export default function ReplyRateCard({ replyRate = 67.4, firstReplyTime = '30 min (Avg)', sx = {} }) {
  const value = Math.max(0, Math.min(100, Number(replyRate) || 0));

  return (
    <Box
      sx={{
        background: '#fff',
        borderRadius: 2, 
        width: '100%', 
        ...sx,
      }}
    >
      {/* Top row: label left / percent right */}
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography sx={{fontSize:'14px', color:'#4A5565'}}>Reply Rate</Typography>
        <Typography sx={{ fontWeight: 600, fontSize:'16px', color:'#101828' }}>{`${value.toFixed(1)}%`}</Typography>
      </Stack>

      {/* Progress bar */}
      <Box sx={{ mt: 1 }}>
        <LinearProgress
          variant="determinate"
          value={value}
         sx={{
    height: 8,
    borderRadius: 2,
    backgroundColor: "#E0E0E0",       // Track color
    "& .MuiLinearProgress-bar": {
      backgroundColor: "#155DFC",     // Progress color (Green)
    },
  }}
          aria-label={`Reply rate ${value.toFixed(1)} percent`}
        />
      </Box>

      {/* Bottom row: label left / time right */}
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mt: 1 }}>
        <Typography variant="caption" sx={{fontSize:'14px', color:'#6A7282'}}>First Reply Time</Typography>
        <Typography variant="caption" sx={{fontSize:'16px', color:'#101828'}}>{firstReplyTime}</Typography>
      </Stack>
    </Box>
  );
}
